module.exports = new __parcel__URL__("generic-error.bc45c66a.svg").toString();